import * as Experiences from '@/src/experiences'

export default Experiences.Mortgage.Screens.MortgageIndex
